import { Component, HostBinding, inject } from '@angular/core';
import { AppService } from '../../app.service';

@Component({
    selector: 'oc-footer',
    templateUrl: './oc-footer.component.html',
    styles: [':host { display: block; }'],
    standalone: false
})
export class OcFooterComponent {
  private appService = inject(AppService);

  @HostBinding('class.oc-footer') private hostClassMain = true;

  currentBg() {
    return `bg-${this.appService.layoutFooterBg}`;
  }
}
